import { memo, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { BaseRichEditor, BaseSelect } from '~/components/common';
import { Typography } from '@mui/material';
import { useAppDispatch } from '~/redux/hooks';
import { handleGetTemplate, handleGetTemplates } from '~/thunks/template/templateThunk';
import { handleApiError } from '~/utils/helper';
import { IResponseGetEstimate } from '~/utils/interface/estimate';
import { ITemplate } from '~/utils/interface/job';

type OpeningStatementProps = {
  form: any;
  editData?: IResponseGetEstimate | undefined;
};
function OpeningStatement(props: OpeningStatementProps) {
  const { form } = props;
  const { t } = useTranslation('admin/job');
  const TYPE: string = 'openingStatement';
  const dispatch = useAppDispatch();
  const [openingStatementId, setOpeningStatementId] = useState<string>('');
  const [openingStatements, setOpeningStatements] = useState<ITemplate[]>([]);

  useEffect(() => {
    props.editData?.openingStatement && form.setFieldValue('openingStatement', props.editData?.openingStatement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onChangeValue = (value: string) => {
    form.setFieldValue('openingStatement', value);
  };

  useEffect(() => {
    (async () => {
      try {
        const result = await dispatch(handleGetTemplates({ limit: 0, type: 'openingStatement' })).unwrap();
        setOpeningStatements(result.responses as ITemplate[]);
      } catch (e) {
        handleApiError(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectOpeningStatementTemplates = async (event: React.ChangeEvent<HTMLButtonElement>) => {
    const { value } = event.target;
    setOpeningStatementId(value);
    const response = await dispatch(handleGetTemplate({ type: TYPE, id: value })).unwrap();
    form.setFieldValue('openingStatement', response.content);
  };
  return (
    <Box>
      <Box className='bg-[#F3F9FF] w-full my-4 p-5 font-[600] text-[14px] border-y-2 border-solid border-y-[#e5eaef]'>
        {t('estimate.openingStatements.title')}
      </Box>
      <Box component='form' className='p-5'>
        <Box className='block right'>
          <Box className='flex justify-end pb-5'>
            <Typography className='px-2 content-center'>
              {t('estimate.openingStatements.importFromTemplate')}
            </Typography>
            <Box className='w-[200px]'>
              <BaseSelect
                name='openingStatementId'
                value={openingStatementId}
                options={openingStatements}
                onChange={(event) => handleSelectOpeningStatementTemplates(event)}
              ></BaseSelect>
            </Box>
          </Box>
        </Box>
        <BaseRichEditor
          onCreateNew={onChangeValue}
          valueProps={form.values.openingStatement}
          isError={Boolean(form.errors?.openingStatement)}
          errorMessage={form.errors.openingStatement}
        />
      </Box>
    </Box>
  );
}

export default memo(OpeningStatement);
